import { useState } from 'react'
import { motion } from 'framer-motion';
import "../sass/pages/_cardquote.scss";

export default function CardQuote({src, alt, txtOne, txtTwo, authorOne, authorTwo}) {

    const [isLoaded, setIsLoaded] = useState(false);
    const [isInView, setIsInView] = useState(false);

    const hiddenMask = `repeating-linear-gradient(to right, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 30px, rgba(0,0,0,1) 30px, rgba(0,0,0,1) 30px)`;
    const visibleMask = `repeating-linear-gradient(to right, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 0px, rgba(0,0,0,1) 0px, rgba(0,0,0,1) 30px)`;

    return (
        <div className='quote'>
            {src ?
                <motion.div
                    className="quote-img"
                    initial={false}
                    animate={
                    isLoaded && isInView
                        ? { WebkitMaskImage: visibleMask, maskImage: visibleMask }
                        : { WebkitMaskImage: hiddenMask, maskImage: hiddenMask }
                    }
                    transition={{ duration: 1, delay: .3 }}
                    viewport={{ once: true }}
                    onViewportEnter={() => setIsInView(true)}
                    >
                    <img src={src} alt={alt} onLoad={() => setIsLoaded(true)}/>
                </motion.div>
                :
                null
            }
            <div className="quote-txt">
                <blockquote>
                    <p>
                        {txtOne}
                    </p>
                </blockquote>
                <p>—{authorOne}</p>
                <blockquote>
                    <p>
                        {txtTwo}
                    </p>
                </blockquote>
                <p>—{authorTwo}</p>
            </div>
        </div>
    )
}
